import $ from 'jquery';
import SubRouteHelper from 'routes/helper';
import TransactionDetailsView from 'view/txndetails/modules';
import TransactionDetailsModel from 'model/txndetails/modules';
import { printPreview } from 'lib/printPreview';

export default SubRouteHelper.extend({

	/**
	 * There is no need to handle the '' route, because
	 * https://www.paypal.com/myaccount/transaction will cause a server-side redirect to
	 * https://www.paypal.com/myaccount/activity
	 */
	routes: {
		// loads full-page transaction details, with server-side rendered content (doesn't fetch the model)
		'details/:id': 'showTransactionDetails',
		'request/cancel/:legId/:id': 'setupReqMoneyCancelAction',
		'request/remind/:legId/:id': 'reqMoneyRemindAction',
		'request/edit/:legId/:id': 'setupReqMoneyEditAction',
		'print-details/:id': 'showTransactionDetailsPrint',
		'print-orders/:id': 'showTransactionDetailsPrint',
		'print-money-requests/:legId/details/:id': 'showTransactionDetailsPrint',

		// Payment actions
		'accept/setup/:id': 'setupAcceptAction',
		'deny/setup/:id': 'setupDenyAction',
		'cancel/setup/:id': 'setupCancelAction',
		'paynow/setup/:id': 'setupPayNowAction',
		'boleto/cancel/setup/:id': 'setupCancelBoletoAction'
	},

	getTxnDetailsModel: function (id) {
		let transactionDetailsModel = new TransactionDetailsModel({ id }),
			serverData = $('#js_transactionDetailsView').data();

		transactionDetailsModel.set('isFullPageView', true);
		transactionDetailsModel.set('data', serverData);

		return transactionDetailsModel;
	},

	/**
	 * Handle showing transaction details in full page view
	 * @param id The transaction ID
	 */
	showTransactionDetails: function (id) {

		/* Element .js_fullpageTransactionDetails-main is already attached with transactiondetails view
		   during the initial load of activity page. Now we are explicitly removing it so that
		   duplicate requests will not be fired */
		if (SubRouteHelper.view) {
			SubRouteHelper.view.remove();
		}

		let transactionDetailsModel = this.getTxnDetailsModel(id),
			transactionDetailsView;

		transactionDetailsView = new TransactionDetailsView({
				el: '.js_fullpageTransactionDetails-main',
				model: transactionDetailsModel
			});

		return transactionDetailsView;
	},


	setupReqMoneyCancelAction: function (legId, id) {
		this.setupReqMoneyAction(legId, id, 'requestCancel');
	},

	setupReqMoneyEditAction: function (legId, id) {
		this.setupReqMoneyAction(legId, id, 'requestEdit');
	},

	setupReqMoneyAction: function(legId, id, action) {
		let transactionDetailsModel = this.getTxnDetailsModel(id),
			transactionDetailsView,
			txnAction = {
				selectedAction: action,
				state: 'initiate'
			};

		if (action === 'requestEdit') {
			txnAction.invalidAmount = false;
			txnAction.editAmount = '';
		}

		transactionDetailsModel.set('groupRequestId', legId);
		transactionDetailsModel.set('txnAction', txnAction);

		transactionDetailsView = new TransactionDetailsView({
			el: '.js_fullpageTransactionDetails-main',
			model: transactionDetailsModel
		});

		return transactionDetailsView;
	},

	reqMoneyRemindAction: function (legId, id) {
		let transactionDetailsModel = this.getTxnDetailsModel(id),
			transactionDetailsView;

		transactionDetailsModel.set('groupRequestId', legId);

		transactionDetailsView = new TransactionDetailsView({
			el: '.js_fullpageTransactionDetails-main',
			model: transactionDetailsModel
		});

		return transactionDetailsView;
	},

	setupAcceptAction: function(id) {
		this.setupPaymentAction(id, 'accept');
	},

	setupDenyAction: function(id) {
		this.setupPaymentAction(id, 'deny');
	},

	setupCancelBoletoAction: function(id) {
		this.setupPaymentAction(id, 'boletoCancel');
	},

	setupCancelAction: function(id) {
		this.setupPaymentAction(id, 'cancel');
	},

	setupPayNowAction: function(id) {
		this.setupPaymentAction(id, 'payNow');
	},

	setupPaymentAction(id, action) {
		let transactionDetailsModel = this.getTxnDetailsModel(id),
			transactionDetailsView,
			txnAction = {
				selectedAction: action,
				state: 'initiate'
			};

		transactionDetailsModel.set('txnAction', txnAction);

		transactionDetailsView = new TransactionDetailsView({
			el: '.js_fullpageTransactionDetails-main',
			model: transactionDetailsModel
		});

		return transactionDetailsView;
	},

	/**
	 * Handle showing print-view of transaction details in full page view
	 * Follows example from the GMail experience of printing an email
	 *
	 * @param id The transaction ID
	 */
	showTransactionDetailsPrint: function (id) {
		let transactionDetailsView = this.showTransactionDetails(id);

		// Pop up browser print dialog.
		printPreview(() => window.print());

		return transactionDetailsView;
	}
});



// WEBPACK FOOTER //
// ./routes/transaction.es6